module.exports = __webpack_public_path__ + "img/country-and-city.ad793ceb.svg";